<template>
  <a-list>
    <ListItemApproval
      v-for="item in workLeaveApprovals"
      :key="item.id"
      :workLeaveApproval="item"
      :department="
        item.approvalStep === 1
          ? 'Department Manager / Giám đốc - Trưởng bộ phận'
          : 'Phòng NS-PL'
      "
      :step="item.approvalStep"
      :status="item.status"
    />
    <!-- <a-list-item slot="renderItem" slot-scope="item">
      <span slot="actions" v-if="item">
        <BadgeStatusApproval :approvalStatus="item.approvalStatus" />
      </span>
      <a-list-item-meta>
        <div slot="description" style="white-space: pre-line;">
          {{ item.note }}
        </div>

        <div slot="title">
          <span v-if="item.approvalStep === 1">
            Giám đốc / Trưởng bộ phận
          </span>
          <span v-else>
            Phòng NS-PL
          </span>
          <span v-if="item && item.id">
            <a-divider type="vertical" />
            <span v-if="item && item.author">
              {{ item.author.fullname || item.author.username }}
            </span>
            <a-divider type="vertical" />
            <span v-if="item">
              {{ item.createdAt | formatDateHour }}
            </span>
          </span>
        </div>
      </a-list-item-meta>
    </a-list-item> -->
  </a-list>
</template>
<script>
import BadgeStatusApproval from "./badgeStatusApproval";
import ListItemApproval from "./listItemApproval";
export default {
  components: { ListItemApproval },
  props: {
    workLeaveApprovals: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
